var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "brb-input-group",
        _vm._b(
          {
            staticClass: "flex-nowrap",
            attrs: {
              prepend: _vm.label,
              append: _vm.append,
              size: _vm.size,
              required: _vm.required,
            },
            scopedSlots: _vm._u(
              [
                _vm.$slots.prepend
                  ? {
                      key: "prepend",
                      fn: function () {
                        return [_vm._t("prepend")]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.$slots.append
                  ? {
                      key: "append",
                      fn: function () {
                        return [_vm._t("append")]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          "brb-input-group",
          _vm.inputGroupAttrs,
          false
        ),
        [
          _c(
            "vue-multiselect",
            _vm._b(
              {
                staticClass: "flex-grow-1 mw-100",
                class: { miniMulti: _vm.size === "sm" },
                attrs: {
                  options: _vm.computedOptions,
                  loading: _vm.loading,
                  "track-by": _vm.trackBy,
                  label: _vm.optionLabel,
                  multiple: _vm.multiple,
                  placeholder: _vm.model
                    ? _vm.$attrs.multiple
                      ? _vm.$t("forms.choose")
                      : _vm.model[_vm.optionLabel]
                    : _vm.$t("forms.choose"),
                  "show-labels": _vm.showLabels,
                  "allow-empty": _vm.allowEmpty,
                },
                on: {
                  open: _vm.onMultiselectOpen,
                  select: function ($event) {
                    return _vm.$emit("select", $event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function ({ option }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between",
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(option[_vm.optionLabel])),
                            ]),
                            _vm.optionTags.includes(option[_vm.trackBy])
                              ? _c(
                                  "span",
                                  _vm._b({}, "span", _vm.optionTagBind, false),
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.optionTagText) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "single-label",
                    fn: function () {
                      return [
                        _vm.model
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.model[_vm.optionLabel])),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "placeholder",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "placeholder" }, [
                          _vm._v(_vm._s(_vm.placeholder)),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "noResult",
                    fn: function () {
                      return [_c("span", [_vm._v(_vm._s(_vm.noResult))])]
                    },
                    proxy: true,
                  },
                  {
                    key: "noOptions",
                    fn: function () {
                      return [_c("span", [_vm._v(_vm._s(_vm.noOptions))])]
                    },
                    proxy: true,
                  },
                  {
                    key: "tag",
                    fn: function ({ option, remove }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center bg-success rounded px-1 flex-shrink-0",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(option[_vm.optionLabel]) + " "
                              ),
                            ]),
                            _c(
                              "brb-btn",
                              {
                                staticClass: "px-1 text-white",
                                attrs: { variant: "transparent" },
                                on: {
                                  click: function ($event) {
                                    return remove(option)
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mx-1",
                                  attrs: { icon: "times", size: "xs" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              },
              "vue-multiselect",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
      _vm.error && typeof _vm.error === "string"
        ? _c(
            "span",
            { staticClass: "d-block text-right text-danger small mt-2" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }